var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphical elements / loading logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphical-elements-/-loading-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 38.5,
    cy: 38.5,
    r: 30.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9564593,30.6375392 C62.5929684,33.3782005 60.0524831,35.3092986 57.2815235,34.9497822 C57.2169907,34.9413154 57.1557504,34.9263355 57.0925346,34.9159147 L54.3195995,40.3776985 C56.4103307,42.4585951 57.7036208,45.3243056 57.7036208,48.4896132 C57.7036208,54.8469314 52.4935846,60 46.0659856,60 C39.6383865,60 34.4283503,54.8469314 34.4283503,48.4896132 C34.4283503,44.8013135 36.189174,41.5259366 38.9179897,39.4196393 L33.3115377,28.2596507 C32.4377109,28.5618529 31.5019852,28.7344469 30.5241157,28.7344469 C29.2571655,28.7344469 28.0606747,28.4517836 26.9820549,27.9587511 L22.3159381,37.1505176 C24.3395024,38.7377305 25.4997759,41.2992849 25.140236,44.0164995 C24.5943412,48.1340045 20.7776867,51.0342338 16.6146624,50.4943079 C12.4522965,49.9550333 9.52000489,46.1794597 10.0652412,42.062606 C10.6111361,37.945101 14.4277905,35.0448717 18.5908149,35.5847976 C18.9845967,35.6355989 19.363233,35.7248267 19.7326504,35.8309882 L24.5680013,26.3070598 C23.0225064,24.7908384 22.0637333,22.6904029 22.0637333,20.3672234 C22.0637333,15.7456139 25.8514139,12 30.5241157,12 C35.196159,12 38.9838395,15.7456139 38.9838395,20.3672234 C38.9838395,22.9886973 37.7629842,25.3268565 35.8553155,26.860663 L41.4196236,37.9392393 C42.8439548,37.3250655 44.4131556,36.9792263 46.0659856,36.9792263 C48.2265175,36.9792263 50.2421799,37.5719074 51.9760051,38.5866294 L54.486858,33.6406736 C53.336462,32.5758016 52.7010114,30.9996608 52.9216083,29.3368974 C53.2844407,26.5955847 55.8255845,24.6651379 58.596544,25.0246543 C61.3675036,25.3835195 63.3199502,27.8968778 62.9564593,30.6375392 L62.9564593,30.6375392 Z M72.9279148,34.8161265 C71.7981433,15.9519155 56.1484482,1 37,1 C17.1175935,1 1,17.1177402 1,37.0003277 C1,56.8822598 17.1175935,73 37,73 C43.5237098,73 49.6358788,71.2561778 54.9125148,68.2220189 L54.9125148,73 L73,73 L73,34.8161265 L72.9279148,34.8161265 Z",
    id: "Fill-75",
    fill: "#BA9666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.789e8ded968a0e4ec77f2cb0d8ed3025.svg";
export { ForwardRef as ReactComponent };